$ = require 'jquery'
Dialog = require 'views/lib/dialog'
LabelState = require 'view-models/label-state'
Layout = require 'views/lib/layout'
PopOver = require 'views/lib/pop-over'
SidebarState = require 'view-models/sidebar-state'
View = require 'view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
track = require 'debug/track'

module.exports = class ApplicationView extends View

  initialize: ->
    @updatePinnedDrawer()
    WindowSize.ensureRun()
    window.Dialog = Dialog

    @listenTo SidebarState, 'change:pinBoardsListSidebar', ->
      @updatePinnedDrawer()

    @initLabelState()

    windowEvent = (ev) ->
      WindowSize.calc()
      PopOver.onWindowResize()
      if Dialog.isVisible
        Dialog.calcPos()
      return

    debouncedWindowEvent = @debounce(windowEvent, 300)

    $(window).on 'resize.windowEvent', debouncedWindowEvent

    return

  updatePinnedDrawer: ->
    $('#trello-root').toggleClass('body-pinned-drawer', SidebarState.getPinSidebar())

  initLabelState: ->
    if LabelState.getShowText()
      $('#trello-root').addClass('body-card-label-text')
    @listenTo LabelState, 'change:showText', @toggleLabelText

  toggleLabelText: ->
    if @resetLabelTextAnimationTimer
      clearTimeout(@resetLabelTextAnimationTimer)

    # The class has to be on the body so it can apply to cards being dragged,
    # which are directly under the body in the DOM.

    if LabelState.getShowText()
      $('#trello-root')
      .removeClass('body-card-label-text-off')
      .addClass('body-card-label-text-on')
    else
      # 'body-card-label-text' is the class present if the label text was
      # already showing on board load
      $('#trello-root')
      .removeClass('body-card-label-text-on body-card-label-text')
      # this class is necessary to be able to animate the label collapse:
      .addClass('body-card-label-text-off')

    # Animation should be done in 660ms. Leave a bit of error margin.
    @resetLabelTextAnimationTimer = setTimeout(@resetLabelTextAnimation, 1000)

  resetLabelTextAnimation: ->
    $body = $('#trello-root')
    # add the non-animating class to keep label text showing, but the labels
    # don't reanimating when dragging cards, etc
    if LabelState.getShowText()
      $body.addClass('body-card-label-text')
    $body
      .removeClass('body-card-label-text-on')
      .removeClass('body-card-label-text-off')



// WEBPACK FOOTER //
// ./app/scripts/views/application-view.coffee